class CookieConsentPopup extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('.cookie-consent-popup__dialog');
    this.acceptButton = this.querySelector('[data-cookie-accept]');
    this.declineButton = this.querySelector('[data-cookie-decline]');
    this.closeButtons = this.querySelectorAll('[data-cookie-popup-close], [data-cookie-decline]');
    this.privacyUrl = this.dataset.privacyUrl || '';
  }

  connectedCallback() {
    if (Shopify?.designMode) return;

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.decline());
    });

    this.acceptButton?.addEventListener('click', () => this.accept());

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-visible')) {
        this.decline();
      }
    });

    this.loadConsentApi();
  }

  dispatchCookieEvent(name) {
    document.dispatchEvent(new CustomEvent(name));
  }

  skipCookieBanner() {
    this.dispatchCookieEvent('livdon:cookie-banner-skipped');
  }

  loadConsentApi() {
    if (!window.Shopify?.loadFeatures) {
      this.skipCookieBanner();
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          this.skipCookieBanner();
          return;
        }

        if (this.shouldShow()) {
          this.open();
          return;
        }

        this.skipCookieBanner();
      }
    );
  }

  shouldShow() {
    const api = window.Shopify?.customerPrivacy;
    if (!api || typeof api.shouldShowBanner !== 'function') return false;
    return api.shouldShowBanner();
  }

  setConsent(consent) {
    return new Promise((resolve) => {
      const api = window.Shopify?.customerPrivacy;
      if (!api?.setTrackingConsent) {
        resolve();
        return;
      }

      api.setTrackingConsent(consent, () => resolve());
    });
  }

  open() {
    this.removeAttribute('hidden');
    this.dispatchCookieEvent('livdon:cookie-banner-opened');
    window.requestAnimationFrame(() => {
      this.classList.add('is-visible');
    });
  }

  close() {
    this.classList.remove('is-visible');

    window.setTimeout(() => {
      if (!this.classList.contains('is-visible')) {
        this.setAttribute('hidden', '');
      }

      this.dispatchCookieEvent('livdon:cookie-banner-closed');
    }, 350);
  }

  async accept() {
    await this.setConsent({
      analytics: true,
      marketing: true,
      preferences: true,
    });
    this.close();
  }

  async decline() {
    await this.setConsent({
      analytics: false,
      marketing: false,
      preferences: false,
    });
    this.close();
  }
}

customElements.define('cookie-consent-popup', CookieConsentPopup);
